import { render, staticRenderFns } from "./ChartsCompensacoesServicos.vue?vue&type=template&id=31ddd4d2&"
import script from "./ChartsCompensacoesServicos.vue?vue&type=script&lang=js&"
export * from "./ChartsCompensacoesServicos.vue?vue&type=script&lang=js&"
import style0 from "./ChartsCompensacoesServicos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VSimpleTable})
